import { AxiosError, AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';

import { KeyValue } from '@/main/models/common';
import { Result } from '@models/common/resultResponse';

import { saveUserHierarchy } from './index';

import { GetUserHierarchy } from './userHierarchyTypes';

import { userHierarchyApi } from '../../api';

import {
    errorBoundaryReduxSaga,
    renderErrorReduxSaga
} from '@/main/services/utils';

export function* getUserHierarchySaga(action: GetUserHierarchy) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      userHierarchyApi.getLevelHierarchy,
      action.payload.guidInsurer,
      action.payload.idSystemApplication
    );

    if (response.data.result) {
      yield put(saveUserHierarchy(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveUserHierarchy(null, true, resultError.messagesDataError));
    }
  }
}
